import type { BlockType } from '@domain/schemas/block.schema';

import type { BlockLayoutOption } from './types';

export const findOptionWithFallback = (options: BlockLayoutOption[], type: BlockType): BlockLayoutOption =>
  options.find((o) => o.type === type) ?? options[0];
